/**
 * Finds and returns the entry in `extended` whose `pause` value is the largest value less than
 * `currentVideoTime`, or `undefined` if no such entry exists.
 */
export function getReferencePosition({
  currentVideoTime,
  extended,
}: {
  currentVideoTime: number;
  extended: { pause: number; play: number }[];
}) {
  // find the most recent pause point before the current position
  // it's important for `extended` to be sorted for this to work correctly
  //
  // NOTE: The `Array.prototype.findLast` method is not available in our environment, so we are
  // manually looping backwards through the array to find the last pause point that occurs before
  // the current video position.
  //
  // This is the reference code that works if we could use `findLast`:
  // const referencePosition = extended.findLast(
  //   ({ pause }) => pause < currentVideoTime * 1000
  // );
  let referencePosition = undefined;
  for (let i = extended.length; i > 0; i--) {
    const entry = extended[i - 1];
    if (entry.pause < currentVideoTime * 1000) {
      // we've found the last one that satisfies the criteria, we don't need to continue looping
      referencePosition = entry;
      break;
    }
  }

  return referencePosition;
}
